import {
  TransactionAccount,
  TransactionCategory,
  TransactionDirection,
  TransactionReason,
  Wallet,
} from '@aslanpay/portal-common-lib';

export interface AdjustBalanceModalProps {
  isOpen: boolean;
  onClose: () => void;
  wallet?: Wallet;
  individualName?: string;
  onSuccess?: () => void;
}

export interface ChildTransactionFormFields {
  transactionAccount: TransactionAccount;
  amount: string;
}

export interface AdjustBalanceFormFields {
  transactionDirection?: TransactionDirection;
  transactionCategory?: TransactionCategory;
  transactionReason?: TransactionReason;
  reference?: string;
  notes?: string;
  childTransactions: ChildTransactionFormFields[];
}

export const getDefaultAdjustBalanceFormFields = (
  accounts: TransactionAccount[]
): AdjustBalanceFormFields => ({
  transactionDirection: 'CREDIT',
  transactionCategory: undefined,
  transactionReason: undefined,
  reference: '',
  notes: '',
  childTransactions: accounts.map((transactionAccount) => ({
    transactionAccount,
    amount: '',
  })),
});
